<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style lang='scss'>

body {
  margin:0;
  height: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}

label {
  font-weight: 700;
}

html {
  height: 100%;
  box-sizing: border-box;
}

#app{
  height: 100%;

}

*,
*:before,
*:after {
  box-sizing: inherit;
}

.no-padding {
  padding: 0px !important;
}

.padding-content {
  padding: 4px 0;
}

a:focus,
a:active {
  outline: none;
}

a,
a:focus,
a:hover {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
}

div:focus{
  outline: none;
 }

.fr {
  float: right;
}

.fl {
  float: left;
}

.pr-5 {
  padding-right: 5px;
}

.pl-5 {
  padding-left: 5px;
}

.block {
  display: block;
}

.pointer {
  cursor: pointer;
}

.inlineBlock {
  display: block;
}

.clearfix {
  &:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }
}

code {
  background: #eef1f6;
  padding: 15px 16px;
  margin-bottom: 20px;
  display: block;
  line-height: 36px;
  font-size: 15px;
  font-family: "Source Sans Pro", "Helvetica Neue", Arial, sans-serif;
  a {
    color: #337ab7;
    cursor: pointer;
    &:hover {
      color: rgb(32, 160, 255);
    }
  }
}

.warn-content{
  background: rgba(66,185,131,.1);
  border-radius: 2px;
  padding: 16px;
  padding: 1rem;
  line-height: 1.6rem;
  word-spacing: .05rem;
  a{
    color: #42b983;
    font-weight: 600;
  }
}

//main-container全局样式
.app-container {
  padding: 20px;
}

.components-container {
  margin: 30px 50px;
  position: relative;
}

.pagination-container {
  margin-top: 30px;
}

.text-center {
  text-align: center
}

.sub-navbar {
  height: 50px;
  line-height: 50px;
  position: relative;
  width: 100%;
  text-align: right;
  padding-right: 20px;
  transition: 600ms ease position;
  background: linear-gradient(90deg, rgba(32, 182, 249, 1) 0%, rgba(32, 182, 249, 1) 0%, rgba(33, 120, 241, 1) 100%, rgba(33, 120, 241, 1) 100%);
  .subtitle {
    font-size: 20px;
    color: #fff;
  }
  &.draft {
    background: #d0d0d0;
  }
  &.deleted {
    background: #d0d0d0;
  }
}

.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
  &:hover {
    color: rgb(32, 160, 255);
  }
}

.filter-container {
  padding-bottom: 10px;
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}

//refine vue-multiselect plugin
.multiselect {
  line-height: 16px;
}

.multiselect--active {
  z-index: 1000 !important;
}
.el-munu{
  border-right: none !important;
}
.main-table {
  
  padding:18px;
  background-color:#ffffff;
  margin-bottom:20px;
  overflow-y:auto;
}
.normal-card {
  width:300px;
  min-height:200px;
  display:inline-block;
  margin-right:20px;
}
.normal-card-200 {
  width:200px;
  min-height:200px;
  display:inline-block;
  margin-right:20px;
}
.blue-color {
  color:#409EFF;
}
.gray-color {
  color:#666;
}
.gray-color2 {
  color:#333333;
}
.red-color {
  color:#E02020;
}
.f10 {
  font-size:10px;
}
.f12 {
  font-size:12px;
}
.f14 {
  font-size:14px;
}
.f13 {
  font-size:13px;
}
.f18 {
  font-size:18px;
}
.f26 {
  font-size:26px;
}
.bold {
  font-weight:bold;
}
.normal {
  font-weight:normal;
}
.dis-inline-div {
  display:inline-block;
}
.width-100 {
  width:100px;
}
.width-200{
  width:200px;
}
.align-left {
  text-align:left;
}
.align-center {
  text-align:center;
}
.align-right {
  text-align:right;
}
.line {
  border-bottom:1px solid #d9d9d9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue